module.exports = __webpack_public_path__ + "img/lamp.3e3f13ab.jpg";